import './styles.scss'
import '../../../../../components/Marketing/Campaigns/CreateCampaigns/styles.scss'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { useDispatch /*, useSelector*/ } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Container, Button, Col, Row } from 'reactstrap'

import { FormSteps, Step1, Step2, Step3, Step4 } from 'components/Marketing/Campaigns/index'

import { upsertCampaign, launchCampaign } from 'redux/actions/marketing'

const CreateCampaign = (props) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const getStepNumber = () => {
    const queryParams = queryString.parse(props.location.search)
    const queryParamStep = +queryParams.step
    return queryParamStep && (queryParamStep >= 1) & (queryParamStep <= 4) ? queryParamStep : 1
  }
  const [step, setStep] = useState(getStepNumber())
  const [error, setError] = useState({})
  const [errorMessage, setErrorMessage] = useState(null)

  const onSubmit = async () => {
    try {
      await dispatch(upsertCampaign())

      const nextStep = step + 1
      history.push({ search: `?step=${nextStep}` })
      setStep(nextStep)
    } catch (data) {
      if (data.type) {
        setError({ [data.field]: I18n.t(data.type) })
      } else {
        setError({ global: I18n.t('dashboard_errors_required-field') })
      }
    }
  }

  const onSubmitFinalize = async () => {
    setErrorMessage(null)
    try {
      await dispatch(upsertCampaign())
      await dispatch(launchCampaign())
      history.push('/dashboard/marketing/campaigns')
    } catch (error) {
      console.error(error)
      setErrorMessage(I18n.t(error.type || 'generic_error'))
    }
  }

  const onSubmitSave = async () => {
    setErrorMessage(null)
    try {
      const action = 'saveAndClose'
      await dispatch(upsertCampaign(action))
      history.push('/dashboard/marketing/campaigns')
    } catch (error) {
      console.error(error)
      setErrorMessage(I18n.t(error.type || 'generic_error'))
    }
  }

  const getCurrentFormStep = (step) => {
    const options = {
      1: <Step1 error={error} />,
      2: <Step2 />,
      3: <Step3 error={error} />,
      4: <Step4 />,
    }

    return options[step]
  }

  return (
    <Row className='animated fadeIn'>
      <Col xs={12}>
        <Container className={`py-5 create-campaign new-form`} fluid>
          <FormSteps step={step} />
          <Row className={`form-wrapper step-${step}`}>
            <Col xs={12}>
              <Row>
                <Col xs={12}>{getCurrentFormStep(step)}</Col>
              </Row>
              {step === 4 &&
                <Row>
                  <small className='text-danger'>
                    {errorMessage}
                  </small>
                </Row>
              }
              <Row className='mt-4 padding-left-15 padding-right-15 buttons'>
                {step === 1 && (
                  <Button color='secondary btn-lg new-button secondary' onClick={() => onSubmit()}>
                    {I18n.t('dashboard_continue')}
                  </Button>
                )}

                {step > 1 && step < 4 && (
                  <>
                    <Button outline color='muted btn-lg new-button' onClick={() => setStep(step - 1)}>
                      <img src='./img/icons/back-arrow.svg' alt='back-arrow' />
                      <span>{I18n.t('dashboard_go-back')}</span>
                    </Button>
                    <Button color='secondary btn-lg new-button secondary' onClick={() => onSubmit()}>
                      {I18n.t('dashboard_continue')}
                    </Button>
                  </>
                )}

                {step === 4 && (
                  <Row>
                    <Button outline color='muted btn-lg new-button' onClick={() => {setStep(step - 1); setErrorMessage(null)}}>
                      <img src='./img/icons/back-arrow.svg' alt='back-arrow' />
                      <span>{I18n.t('dashboard_go-back')}</span>
                    </Button>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <Button color='secondary btn-lg new-button secondary' onClick={() => onSubmitFinalize()}>
                      {I18n.t('dashboard_schedule-send')}
                    </Button>
                    <div>&nbsp;&nbsp;&nbsp;</div>
                    <Button className='color-save' color='outline-secondary btn-lg new-button' onClick={() => onSubmitSave()}>
                      {I18n.t('dashboard_save-and-exit')}
                    </Button>
                  </Row>
                )}
              </Row>
            </Col>
          </Row>
        </Container>
      </Col>
    </Row>
  )
}

export default CreateCampaign
